import { createFileRoute } from '@tanstack/react-router'
import { Copia } from '@/features/portal/copia'

/**
 * Cópia levada por link, com a chave no fragmento da URL.
 *
 * Pública e sem sessão: o link é a credencial. O id fica no caminho, a chave
 * depois do `#`, que não sai do navegador.
 */
export const Route = createFileRoute('/portal/copia/$id')({
  component: function CopiaDoPaciente() {
    const { id } = Route.useParams()
    return <Copia id={id} />
  },
})
